import * as React from 'react';
import {View} from 'react-native';

import Screen from '../../shared/components/screen';

import {Props} from './model';
import {Routes, Screens} from '../../shared/routing';
import {Breadcrumbs} from '../../shared/components/breadcrumbs';
import {ResponsiveView} from '../../shared/components/responsiveView';
import {SocialSupportList} from '../../shared/components/socialSupportList';
import {DeviceSize} from '../../shared/theme/helpers';
import {Text} from '../../shared/components/text';
import {CustomScrollView} from '../../shared/components/scrollView';
import {useStyles} from '../../shared/hooks/styles';

const routes = [
  {
    title: 'Меры социальной поддержки',
    routeName: Screens.SocialSupportMeasures,
    webRoute: Routes.socialSupportMeasures,
  },
  {
    title: 'Реестр расходных обязательств',
    routeName: Screens.ExpenseLiabilities,
    webRoute: Routes.expenseLiabilities,
  },
];

export default ({socialSupportData}: Props) => {
  const styles = useStyles(({theme, isDesktop}) => ({
    sectionContainer: {
      marginTop: 32,
      paddingHorizontal: 24,
      marginBottom: theme.screen.bottomOffset - (isDesktop ? 30 : 20),
    },
    sectionTitle: {...theme.fonts.h2, marginBottom: 40, marginTop: 40},
  }));

  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <View>
          <View style={styles.sectionContainer}>
            <Breadcrumbs routes={routes} />
            <ResponsiveView only={[DeviceSize.desktop]}>
              <Text style={styles.sectionTitle}>Реестр расходных обязательств</Text>
            </ResponsiveView>
            <SocialSupportList data={socialSupportData} />
          </View>
        </View>
      </CustomScrollView>
    </Screen>
  );
};
